import config from './config.fr';
import list from './list.fr';
export default {
    breadcrumb: 'Calendar',
    config,
    list,
};
